import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import MuiTextField from "@mui/material/TextField";

import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";

import api from "../service/api";
import { setError } from "../reducers/appSlice";
import Modal from "../components/Modal";

const TextField = styled(MuiTextField)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

var validationSchema = Yup.object().shape({
  cuil: Yup.string()
    .required("Requerido")
    .matches(/^\d{2}-\d{8}-\d{1}$/, "Formato 20-12345678-7"),
});

const FirmaRemota = (props) => {
  const { adjuntoId, nombreAdjunto, handleFirmado, disabled } = props;
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    formik.handleReset();
    setOpen(false);
  };

  const formik = useFormik({
    initialValues: {
      cuil: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      api
        .firmarAdjunto({ adjuntoId: adjuntoId, cuil: formik.values.cuil, nombreArchivo: nombreAdjunto})
        .then((res) => {
          let ventanaFirmador = window.open(res.data.url);
          if (ventanaFirmador) {
            let firmadorTimer = window.setInterval(function () {
              if (ventanaFirmador.closed !== false) {
                window.clearInterval(firmadorTimer);
                handleFirmado();
              }
            }, 200);
          } else {
           dispatch(setError("No se pudo abrir la ventana emergente"));
          }
        })
        .catch((e) =>
          dispatch(
            setError(e.response.data.error ? e.response.data.error : "Error")
          )
        );
      handleClose();
    },
    onReset: () => {
      //
    },
  });

  return (
    <>
      <IconButton
        title="Firma remota"
        size="small"
        onClick={handleOpen}
        disabled={disabled}
      >
        <BadgeOutlinedIcon fontSize="small" />
      </IconButton>

      <Modal open={open} handleClose={handleClose} size="sm">
        <Typography variant="titulo" sx={{ mb: 1 }}>
          FIRMA DIGITAL REMOTA
        </Typography>
        <Typography variant="cuerpo" paragraph>
          <b>Adjunto: {nombreAdjunto}</b>
        </Typography>

        <form
          id="formFirma"
          name="formFirma"
          onSubmit={formik.handleSubmit}
          onReset={formik.handleReset}
          noValidate
          autoComplete="off"
        >
          <Grid container>
            <Grid item lg={12} xs={12}>
              <TextField
                id="cuil"
                name="cuil"
                label="CUIL"
                variant="outlined"
                size="small"
                margin="dense"
                fullWidth
                value={formik.values.cuil}
                onChange={formik.handleChange}
                error={formik.touched.cuil && Boolean(formik.errors.cuil)}
                helperText={
                  (formik.touched.cuil && formik.errors.cuil) ||
                  "Ej. 20-12365478-2"
                }
              />
            </Grid>
          </Grid>
          <br></br>
          <Typography variant="cuerpo" paragraph>
            <b>Importante</b>: Se abrirá el sitio de Firma Digital de Nación en
            una nueva pestaña. Recuerde que necesitará su clave de usuario de
            Firma Digital y el segundo factor de autenticación en su teléfono.
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
            }}
          >
            <Button sx={{ m: 1 }} variant="verde" type="submit">
              {"Firmar"}
            </Button>
            <Button sx={{ m: 1 }} variant="plata" onClick={handleClose}>
              {"Cancelar"}
            </Button>
          </Box>
        </form>
      </Modal>
    </>
  );
};

FirmaRemota.propTypes = {
  adjuntoId: PropTypes.number.isRequired,
  nombreAdjunto: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  actualizarAdjuntos: PropTypes.func.isRequired,
};

FirmaRemota.defaultProps = {
  disabled: false,
};

export default FirmaRemota;
